<template>
  <div v-if="hasSlides" ref="sliderElement" :class="style['slider-wrap']">
    <chat-message
      v-if="hasMessage"
      :prev-chat="prevChat"
      :chat="chat"
      @delete="$emit('delete', chat)"
    ></chat-message>
    <div :class="[style['slider-wrap'], { [style['manual-slider']]: manualSliderMode }]">
      <div ref="theSlider" :class="style['sliders-container']">
        <div ref="spacer" :class="style['spacer-small']"></div>
        <component
          :is="sliderComponent"
          v-for="(slide, index) in displayList"
          ref="slides"
          :key="index"
          :chat="chat"
          :slide="slide"
          :disabled="replied"
          :send-reply="sendReply"
          :show-fallback-image="showFallbackImage"
          :is-multiple-selector="isMultipleSelector"
          @increaseApiCount="increaseApiCount"
          @replied="replied = true"
          @updateQuantity="quantity => handleQuantityUpdate(quantity, index)"
        >
        </component>
        <div :class="style['spacer-small']"></div>
      </div>
      <theme-button v-if="isMultipleSelector" outline block @click="handleConfirm">{{ getMultipleSelectorButtonText }}</theme-button>      
      <button
        v-if="slideCount > 1"
        v-theme
        :class="[style.arrow, style['arrow--left']]"
        @click="move('<')"
      ></button>
      <button
        v-if="slideCount > 1"
        v-theme
        :class="[style.arrow, style['arrow--right']]"
        @click="move('>')"
      ></button>
    </div>
    <button
      v-if="displayLimit && oringinalSlideCount > displayLimit"
      :class="style['see-more']"
      type="button"
      @click="seeMore"
    >
      {{ $t('seeAll') }}
    </button>
  </div>
  <chat-message v-else :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <template v-slot:message>{{ noRooms.message }}</template>
    <ul class="chat-message__actions">
      <li v-theme-bg-hover @click="restartReservation()">
        {{ noRooms.button }}
      </li>
    </ul>
  </chat-message>
</template>

<script>
import { formatPriceTitle } from 'Utilities'
import { EventBus } from 'ChatWidget/EventBus'
import { Chat } from 'src/apis'
import SliderBot from 'UtilityComponents/SliderBot'
import style from './scss/_slider_widget.scss'
import sliderMixin from './mixins/sliderMixin'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'
import { useChatStore } from 'Store/chat'
import ThemeButton from 'javascript/Common/ThemeButton'

export default {
  components: {
    ChatMessage,
    SliderBot,
    ThemeButton
  },
  mixins: [sliderMixin, chatWidgetMixin],

  setup() {
    const chatStore = useChatStore()

    return { chatStore }
  },

  data() {
    const {
      display_limit: displayLimit,
      slides,
      already_sorted: alreadySorted
    } = this.chat.message_rich
    const sortedSlides =
      alreadySorted || this.chat.message_rich.type === 'collect_user_input_slider'
        ? slides
        : slides.sort(function (a, b) {
            return formatPriceTitle(a.price || a.title) - formatPriceTitle(b.price || b.title) // FIXME: after backend change, we can remove title
          })
    return {
      active: this.chat.message_rich.hasOwnProperty('active')
        ? this.chat.message_rich.active
        : true,
      displayList: displayLimit ? sortedSlides.slice(0, displayLimit) : sortedSlides,
      displayLimit,
      replied: false,
      apiCount: 0,
      selectedQuantities: []
    }
  },
  computed: {
    style: () => style,
    hasSlides() {
      return this.displayList.length > 0
    },

    hasMessage() {
      return this.chat.message || (this.chat.message_rich && this.chat.message_rich.message)
    },

    isMultipleSelector(){
        return this.chat.message_rich.multiple_selection
    },

    getMultipleSelectorButtonText(){
      // After BE Refactor Need Refactor Below Code
      return this.displayList[0].submit_button.content || this.$t('base.confirmSelection')
    },

    showFallbackImage() {
      return this.displayList.some((slide) => {
        return slide.media_content || (slide.main_image && slide.main_image.content)
      })
    },

    noRooms() {
      return {
        reply: this.$t('search_again'),
        message: this.$t('room_not_available'),
        button: this.$t('search_again')
      }
    },
    chatID() {
      return this.chatStore.chatId
    },
    slideCount() {
      return this.displayList.length
    },
    oringinalSlideCount() {
      return this.chat.message_rich.slides.length
    },
    sliderComponent() {
      switch (this.chat.message_rich.type) {
        case 'collect_user_input_slider':
          return SliderBot
        default:
          return 'slider'
      }
    }
  },
  mounted() {
    if (this.chat.message_rich.message && this.$refs.sliderElement) {
      EventBus.$emit('scroll-to-slider-message', this.$refs.sliderElement.clientHeight)
    }
    this.$on('updateQuantity', (quantity, index) => {
      this.selectedQuantities[index] = quantity
    })
    this.selectedQuantities = new Array(this.displayList.length).fill(0)
  },
  methods: {
    sendReply(action) {
      if (this.active && !action.url) {
        this.active = false
        if (action.step === 'back') {
          // user clicked back button, call API and return
          Chat.goToState(this.chatID)
          return
        }
        Chat.sendMessage(action.reply, {
          messageID: this.chat.id,
          messageAction: action.action,
          resetValue: action.reset
        })
      }
    },
    handleConfirm(){
      const customBotFormFields = this.displayList.map((item, index) => ({
        id: item.submit_button.id,
        content: item.submit_button.content,
        value: item.submit_button.value,
        quantity: this.selectedQuantities[index]
      })).filter(item => item.quantity > 0)

      Chat.sendMessage('', {
        customBotFormFields
      })
    },
    handleQuantityUpdate(quantity, index){
      this.$set(this.selectedQuantities, index, quantity)
    },  
    restartReservation() {
      const options = {
        messageAction: 'room_reservation',
        resetValue: true,
        useAi: true
      }
      Chat.sendMessage(this.noRooms.reply, options)
    },
    seeMore() {
      this.displayList = this.chat.message_rich.slides
      this.displayLimit = null
    },
    increaseApiCount() {
      this.apiCount += 1
      if (this.apiCount === this.oringinalSlideCount) {
        this.displayList = this.displayList.filter((slider) => {
          return !!slider.price
        })
        this.displayList.sort(function (a, b) {
          return a.price - b.price
        })
      }
    }
  }
}
</script>
